import { render, staticRenderFns } from "./ProductsModal.vue?vue&type=template&id=6d6ab7e2&scoped=true&"
import script from "./ProductsModal.vue?vue&type=script&lang=ts&"
export * from "./ProductsModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsModal.vue?vue&type=style&index=0&id=6d6ab7e2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ab7e2",
  null
  
)

export default component.exports